
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.667 3.333A.667.667 0 002 4v9.333a.667.667 0 00.667.667H12a.667.667 0 00.667-.667v-3.56a.667.667 0 011.333 0v3.56a2 2 0 01-2 2H2.667a2 2 0 01-2-2V4a2 2 0 012-2h3.56a.667.667 0 010 1.333h-3.56z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.529.861c.26-.26.682-.26.942 0l2.667 2.667c.26.26.26.682 0 .943l-6.667 6.666a.667.667 0 01-.471.196H5.333a.667.667 0 01-.666-.667V7.999c0-.176.07-.346.195-.471L11.529.86zM6 8.275V10h1.724l6-6L12 2.275l-6 6z"}})])
          )
        }
      }
    